export default {
  websites: [],
  loading: false
};
